module.exports = __webpack_public_path__ + "static/media/11.37766d17.png";